import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { EMPTY, filter, Observable, switchMap, takeUntil, timer } from 'rxjs';
import { isBrowserVisible } from '@frontend-site/shared/utils';

export const POLLING_DEFAULT_CONFIG = new InjectionToken<TimerParams>('__POLLING_DEFAULT_CONFIG__');
const POLLING_DEFAULT_INTERVAL = 300000;

@Injectable({ providedIn: 'root' })
export class PollingService {
    constructor(@Inject(POLLING_DEFAULT_CONFIG) @Optional() private readonly pollingParams?: TimerParams) {}

    doPolling<TPollingSubject, TStopPolling>(
        subjectOfPolling: Observable<TPollingSubject>,
        config?: PollingConfig<TStopPolling>
    ): Observable<TPollingSubject> {
        const { startDue, intervalInMS, stopPolling } = { ...this.pollingParams, ...config };

        return timer(startDue ?? 0, intervalInMS ?? POLLING_DEFAULT_INTERVAL).pipe(
            filter(() => isBrowserVisible()),
            switchMap(() => subjectOfPolling),
            takeUntil(stopPolling ?? EMPTY)
        );
    }
}

export interface TimerParams {
    startDue?: number;
    intervalInMS?: number;
}

export interface PollingConfig<TStopPolling> extends TimerParams {
    stopPolling?: Observable<TStopPolling>;
}
